export const menFootwears  = [
    {   
        id: 0,
        name: 'Walk hype black',
        price: 12.99,
        image: './asset/men-footwear.png'
    },   
    {
        id: 1,
        name: 'Walk hype white',
        price: 12.99,
        image: './asset/men-footwear1.png'
    },
    {
        id: 2,
        name: 'High cut running',
        price: 17.99,
        image: './asset/men-footwear2.png'
    },
    {
        id: 3,
        name: 'Wolf grey',
        price: 17.99,
        image: './asset/men-footwear3.png'
    },
    {
        id: 4,
        name: '3stripes black',
        price: 14.99,
        image: './asset/men-footwear4.png'
    },
    {
        id: 5,
        name: '3stripes white',
        price: 14.99,
        image: './asset/men-footwear5.png'
    },
    {
        id: 6,
        name: 'Basketball Shoes',
        price: 17.99,
        image: './asset/men-footwear6.png'
    },
    {
        id: 7,
        name: 'Formal blue',
        price: 12.99,
        image: './asset/men-footwear9.png'
    },
    {
        id: 8,
        name: 'Formal brown',
        price: 12.99,
        image: './asset/men-footwear10.png'
    },
    ]